import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import Avatar from '@mui/material/Avatar';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import ForestIcon from '@mui/icons-material/Forest';
import PhotoIcon from '@mui/icons-material/Photo';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Link from '@mui/material/Link';

function getIcon(contract_name:string){
  if (contract_name === "BloomeriaMemberCard") {
    return <CardMembershipIcon/>
  } else if (contract_name === "BloomeriaNFTreeRMTerraBatch1") {
    return <ForestIcon/>
  } else if (contract_name === "RMTerraMoonStone") {
    return <PhotoIcon/>
  }
}

function getTitle(contract_name){
  if (contract_name === "BloomeriaMemberCard") {
    return "Bloomeria's member card"
  } else if (contract_name === "BloomeriaNFTreeRMTerraBatch1") {
    return "RMTerra's Digital Certificates"
  } else if (contract_name === "RMTerraMoonStone") {
    return "RMTerra's MoonStone special"
  }
}


function getCollectionLink(contract_name){
  if (contract_name === "BloomeriaMemberCard") {
    return "https://opensea.io/collection/bloomeria-member-cards"
  } else if (contract_name === "BloomeriaNFTreeRMTerraBatch1") {
    return "https://opensea.io/collection/bloomeria-nftrees-rmterra-anceriz-collection"
  } else if (contract_name === "RMTerraMoonStone") {
    return "https://opensea.io/collection/moonstone-bloomeria-rmterra"
  }
}

class NFTOverview extends React.Component<any, any> {
    constructor(props:any) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            items: []
        }
    }

    componentDidMount() {
      this.props.collections.forEach((col) => {
        
      });
        fetch("https://api.bloomeria.org/nfts", {mode:'cors'})
          .then(res => res.json())
          .then(
            (result) => {
              this.setState({
                isLoaded: true,
                items: result
              });
            },
            (error) => {
              this.setState({
                isLoaded: true,
                error
              });
            }
          )
      }
    
    render() {
        const {error, isLoaded, items } = this.state;
        if (error) {
            return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Loading...</div>;
        } else {
            return (
              <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                {items.map(item => (
                    <ListItem key={item.contract_address}>
                    <ListItemAvatar sx={{marginLeft:-2}}>
                      <Avatar>
                        {getIcon(item.contract_name)}
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={getTitle(item.contract_name)} secondary={item.owners_count + " unique owners"} sx={{overflow: 'hidden',textOverflow: 'ellipsis' }} />
                    <ListItemIcon>
                      <Link href={getCollectionLink(item.contract_name)} target="_blank" sx={{color:(theme)=>theme.palette.info.main}}>
                        <OpenInNewIcon />
                      </Link>
                    </ListItemIcon>
                  </ListItem>
                ))}
              </List>
            );
        }
    }
}

export default NFTOverview